export const DownloadIcon = ({ className, size = 24 }: { className?: string; size?: number }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M69.473 36.819c-2.112-1.781-5.266-1.511-7.046 0.599L50 52.155V5c0-2.761-2.238-5-5-5-2.761 0-5 2.239-5 5v47.155L27.573 37.418c-1.781-2.111-4.935-2.378-7.045-0.599-2.111 1.78-2.379 4.935-0.599 7.045l21.25 25.199c0.075 0.088 0.156 0.168 0.236 0.251 0.028 0.029 0.054 0.059 0.083 0.088 0.2 0.196 0.416 0.372 0.643 0.531 0.044 0.031 0.088 0.061 0.133 0.091 0.23 0.15 0.471 0.282 0.722 0.392 0.05 0.022 0.101 0.04 0.151 0.061 0.264 0.105 0.534 0.193 0.813 0.252 0.035 0.007 0.071 0.011 0.106 0.018 0.306 0.058 0.618 0.094 0.935 0.094 0.317 0 0.628-0.036 0.934-0.094 0.035-0.007 0.071-0.01 0.106-0.018 0.279-0.059 0.549-0.147 0.812-0.252 0.052-0.021 0.103-0.039 0.154-0.062 0.25-0.11 0.49-0.241 0.719-0.39 0.047-0.03 0.092-0.061 0.137-0.093 0.226-0.158 0.441-0.333 0.64-0.528 0.03-0.029 0.057-0.061 0.086-0.091 0.079-0.082 0.161-0.161 0.234-0.249l21.249-25.199c1.78-2.11 1.511-5.264-0.599-7.045z"
        fill="currentColor"
      />
      <path
        d="M75.787 90H14.212c-2.761 0-5-2.238-5-5s2.239-5 5-5h61.575c2.762 0 5 2.238 5 5s-2.238 5-5 5z"
        fill="currentColor"
      />
    </svg>
  );
};
